/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Friendly_Duck_SupportInputs */

const en_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Brave support`)
};

const id_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghubungi dukungan Brave`)
};

const ms_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Brave support`)
};

const ca_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacta amb l'equip d'assistència de Brave`)
};

const cs_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte podporu Brave`)
};

const da_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Braves kundeservice`)
};

const de_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-Support kontaktieren`)
};

const et_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Võtke ühendust Brave'i klienditoega`)
};

const es_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunícate con el equipo de Soporte de Brave`)
};

const fr_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez l’assistance Brave`)
};

const hr_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontektirajte podršku Brave`)
};

const it_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta l'assistenza di Brave`)
};

const lv_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sazināties ar Brave atbalsta dienestu`)
};

const lt_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susisiekti su „Brave“ pagalbos skyriumi`)
};

const hu_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépjen kapcsolatba az ügyfélszolgálattal`)
};

const nl_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact opnemen met Brave Support`)
};

const nb_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta kontakt med Braves brukerstøtte`)
};

const pl_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt z pomocą techniczną Brave`)
};

const pt_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato com o suporte do Brave`)
};

const ro_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactează echipa de asistență Brave`)
};

const sk_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktovať podporu Brave`)
};

const sl_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrnite se na podporo Brave`)
};

const fi_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä Braven tukeen`)
};

const sv_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta Brave-support`)
};

const vi_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ bộ phận hỗ trợ của Brave`)
};

const tr_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Destek ile iletişime geçin`)
};

const el_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε με την υποστήριξη Brave`)
};

const bg_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свържи се с поддръжката на Brave`)
};

const ru_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться со службой поддержки Brave`)
};

const sr_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратите се подршци за Brave`)
};

const uk_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв’язатися із службою підтримки Brave`)
};

const ka_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაუკავშირდით Brave-ის მხარდაჭერის გუნდს`)
};

const hi_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव सपोर्ट से संपर्क करें`)
};

const th_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อฝ่ายสนับสนุนของ Brave`)
};

const ko_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 지원팀에 문의`)
};

const zh_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系 Brave 支持`)
};

const zh_tw_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聯絡 Brave 支援`)
};

const ja_warm_friendly_duck_support = /** @type {(inputs: Warm_Friendly_Duck_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braveサポートに連絡`)
};

/**
* | output |
* | --- |
* | "Contact Brave support" |
*
* @param {Warm_Friendly_Duck_SupportInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const warm_friendly_duck_support = /** @type {((inputs?: Warm_Friendly_Duck_SupportInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Friendly_Duck_SupportInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_warm_friendly_duck_support(inputs)
	if (locale === "ms") return ms_warm_friendly_duck_support(inputs)
	if (locale === "ca") return ca_warm_friendly_duck_support(inputs)
	if (locale === "cs") return cs_warm_friendly_duck_support(inputs)
	if (locale === "da") return da_warm_friendly_duck_support(inputs)
	if (locale === "de") return de_warm_friendly_duck_support(inputs)
	if (locale === "et") return et_warm_friendly_duck_support(inputs)
	if (locale === "es") return es_warm_friendly_duck_support(inputs)
	if (locale === "fr") return fr_warm_friendly_duck_support(inputs)
	if (locale === "hr") return hr_warm_friendly_duck_support(inputs)
	if (locale === "it") return it_warm_friendly_duck_support(inputs)
	if (locale === "lv") return lv_warm_friendly_duck_support(inputs)
	if (locale === "lt") return lt_warm_friendly_duck_support(inputs)
	if (locale === "hu") return hu_warm_friendly_duck_support(inputs)
	if (locale === "nl") return nl_warm_friendly_duck_support(inputs)
	if (locale === "nb") return nb_warm_friendly_duck_support(inputs)
	if (locale === "pl") return pl_warm_friendly_duck_support(inputs)
	if (locale === "pt") return pt_warm_friendly_duck_support(inputs)
	if (locale === "ro") return ro_warm_friendly_duck_support(inputs)
	if (locale === "sk") return sk_warm_friendly_duck_support(inputs)
	if (locale === "sl") return sl_warm_friendly_duck_support(inputs)
	if (locale === "fi") return fi_warm_friendly_duck_support(inputs)
	if (locale === "sv") return sv_warm_friendly_duck_support(inputs)
	if (locale === "vi") return vi_warm_friendly_duck_support(inputs)
	if (locale === "tr") return tr_warm_friendly_duck_support(inputs)
	if (locale === "el") return el_warm_friendly_duck_support(inputs)
	if (locale === "bg") return bg_warm_friendly_duck_support(inputs)
	if (locale === "ru") return ru_warm_friendly_duck_support(inputs)
	if (locale === "sr") return sr_warm_friendly_duck_support(inputs)
	if (locale === "uk") return uk_warm_friendly_duck_support(inputs)
	if (locale === "ka") return ka_warm_friendly_duck_support(inputs)
	if (locale === "hi") return hi_warm_friendly_duck_support(inputs)
	if (locale === "th") return th_warm_friendly_duck_support(inputs)
	if (locale === "ko") return ko_warm_friendly_duck_support(inputs)
	if (locale === "zh") return zh_warm_friendly_duck_support(inputs)
	if (locale === "zh-tw") return zh_tw_warm_friendly_duck_support(inputs)
	if (locale === "ja") return ja_warm_friendly_duck_support(inputs)
	return en_warm_friendly_duck_support(inputs)
});